import preparedReducer from './reducer';
import {
  updateFilterState,
  updateActivityFilter,
  updateIRFilter,
  updateMonitoringFilter,
  updateWorkHistoryFilter,
  updateTimesheetsFilter,
  reset,
  updateTab,
  updateActivityMapFilter,
  updateClientDashboardFilter,
  updateAdminClientFilter,
  updateAdminSiteFilter,
  updateAdminEmployeeFilter,
  updateAdminContactFilter,
  updateMobileUnitsFilter,
  setIsFilterSelected,
  updatePerformanceFilter,
  updateInfoBoardFilter,
  updateSort,
  updateFormResultsFilter,
  updateTasksFilter,
  updateToursFilter,
  updateSystemLogFilter,
} from './actions';

import initState from './states';

export { initState };

export const reducer = preparedReducer;

export const SLICE_NAME = 'pageStore';

export const selectors = state => state[SLICE_NAME];

export const selectorsActivityLog = state => state[SLICE_NAME].activityFilters;
export const selectorsInfoBoard = state => state[SLICE_NAME].infoBoardFilters;
export const selectorsMonitoring = state => state[SLICE_NAME].monitoringFilters;
export const selectorsIR = state => state[SLICE_NAME].irFilters;
export const selectorsPerformance = state => state[SLICE_NAME].performanceFilters;
export const selectorsSystemLog = state => state[SLICE_NAME].systemLogFilters;

export const actions = {
  updateFilterState,
  updateActivityFilter,
  updateIRFilter,
  updateMonitoringFilter,
  updateWorkHistoryFilter,
  updateTimesheetsFilter,
  updateActivityMapFilter,
  updateClientDashboardFilter,
  reset,
  updateTab,
  updateAdminClientFilter,
  updateAdminSiteFilter,
  updateAdminEmployeeFilter,
  updateAdminContactFilter,
  updateMobileUnitsFilter,
  setIsFilterSelected,
  updatePerformanceFilter,
  updateInfoBoardFilter,
  updateSort,
  updateFormResultsFilter,
  updateTasksFilter,
  updateToursFilter,
  updateSystemLogFilter,
};
